import axios from "axios";

export const getAddresses = async (token) => {
  return axios.get(`${window.BASE_API_URL}address/${token}`);
};

export const addAddress = async (payload) => {
  return axios.post(`${window.BASE_API_URL}address/add`, payload);
};

export const updateAddress = async (payload) => {
  return axios.post(`${window.BASE_API_URL}address/update`, payload);
};

export const deleteAddress = async (id, token) => {
  return axios.post(`${window.BASE_API_URL}address/delete/${id}`, { token });
};
